import { useCommunitiesStore } from '@/modules/communities/store/communitiesStore'

export default async function (store, i18n, router, pinia) {
  if (!store.getters['auth/isLoggedIn']) {
    return
  }

  const communitiesStore = useCommunitiesStore(pinia)

  await communitiesStore.updateCommunities()
}
